import React from "react";
import Anchor from "@atom/Anchor";
import { Heading } from "@atom/Typography";
import style from "./style.scss";
import cn from "classnames";

const data = {
  link: "https://www.thetrevorproject.org/research-briefs/you-are-beautiful-advice-and-encouragement-for-lgbtq-young-people-from-lgbtq-young-people/",
  title:
    "“You are beautiful”: Advice and encouragement for LGBTQ+ young people from LGBTQ+ young people",
  subtitle:
    "LGBTQ+ young people advise their peers to accept themselves, avoid\nnegativity, find community, and practice perseverance.",
  logo: {
    src: require("@assets/images/trevorlogowhite.png"),
    placeholder: require("@assets/images/trevorlogowhite_thumb.png"),
    alt: "Trevor Logo",
    width: 388,
    height: 159,
  },
};

export default () => (
  <div className={cn(style.trevor)} onClick={() => window.open(data.link)}>
    <div className={cn(style.content)}>
      <div type={"h5"} className={cn(style.left)}>
        <Heading type="h2">{data.title}</Heading>
        <Heading type="h4" weight={500} className={cn(style.subtitle)}>
          {data.subtitle}
        </Heading>
      </div>
      <div className={cn(style.right)}>
        <img {...data.logo} />
      </div>
    </div>
  </div>
);
